<template>
  <div class="goods-module-container">
    <div class="goods-box">
      <!-- <img class="goods-bg" src="../assets/home/goods-module.png" alt="" /> -->
      <div class="goods-box-head">覆盖海量品类</div>
      <div class="goods-box-content">
        <div v-for="moduleItem in moduleList" :key="moduleItem.title" class="goods-box-content-item">
          <div class="goods-box-content-item-label"> {{ moduleItem.title }} </div>
          <div class="goods-box-content-item-list">
            <span class=""> 包括 {{ moduleItem.listStr }}产业链下共计 <span class="goods-count-mark" > {{ moduleItem.count }} </span> 个商品 </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "goods-module",
  data() {
    return {
      moduleList: [
        {
          title: "能源",
          listStr: '油品类、天然气类、液化气类、润滑油类、其他石油产品、煤炭产业、工业气体',
          count: 51
        },

        // --------待
        {
          title: "化工",
          listStr: '芳烃、烯经、酚酮、增塑剂、醇类、化纤原料、丙烯酸及酯、甲醇产业、醋酸产业、UPR 及原料、环氧乙烷及下游、醇醚及酯、其他有机、氯碱产业、杀菌消毒剂、其他无机、氯化物、氟化工、染料、化纤产业、石油树脂、有机硅产业、医药化工、油脂化工',
          count: 202
        },
        {
          title: '农化',
          listStr: '氮肥产业、磷肥产业、钾肥及复合肥、水溶肥产业、磷化工产业、农药除草剂、农药杀虫剂、农药杀菌剂',
          count: 71
        },
        {
          title: '煤化工',
          listStr: '煤焦化、煤焦油深加工、粗笨精致、煤精细化工、炭黑相关、煤基新型碳材料',
          count: 28
        },
        {
          title: '橡塑',
          listStr: '通用塑料、工程塑料、塑料制品、塑料管材、再生塑料、可降解塑料、天然橡胶、合成橡胶、特种橡胶、橡胶助剂、再生橡胶、轮胎',
          count: 43
        },

        {
          title: '钢铁',
          listStr: '冶金产业、不锈钢产业、冶金原料、耐火材料、炭素',
          count: 38
        },
        {
          title: '有色',
          listStr: '稀土产业、 铜产业、铝产业、铅产业、锌产业、锡产业、镍产业、gu产业、锂产业、锑产业、镁产业、其他小金属、贵金属、钼产业、钨产业、钒产业、铬产业、硅产业、锰产业、铌钽产业、钛产业、镐产业、其他铁合金',
          count: 141
        },

        {
          title: '建材',
          listStr: '水泥产业、玻璃产业、木材产业、油漆涂料、非金属矿、废旧物资',
          count: 24
        },
        {
          title: '纸品',
          listStr: '纸浆、废纸、包装纸、印刷纸、生活用纸',
          count: 22
        },
        {
          title: '新材料',
          listStr: '理电产业、纤维材料、光伏产业、氢能源、电子材料',
          count: 22
        }
      ],
    };
  },
};
</script>

<style lang="scss" scoped >
.goods-module-container {
  padding: 0;
  background: #f5f6f9;

  .goods-box {
    height: 0;
    width: 100%;
    overflow: hidden;

    // height: 650px;
    // background: url(../assets/home/goods-module.png)  ;
    // background-position: top left;
    // background-size: contain;
    // background-repeat: no-repeat;
    .goods-bg {
      width: 100%;
      max-height: 650px;
    }

    .goods-head {
      min-width: 8rem;
      height: 30px;
      line-height: 30px;
      text-align: center;
    }
  }
}

@media (min-width: 1280px) {
  .goods-module-container {
    padding: 20px;

    .goods-box {
      width: 1200px;
      height: auto;
      margin: 20px auto;

      .goods-box-head {
        text-align: center;
        padding-bottom: 20px;
        font-weight: bold;
        color: #111111;
        font-size: 1.2rem;
      }

      .goods-box-content {
        background-color: #ffffff;
        .goods-box-content-item {
          display: flex;
          align-items: stretch;
          min-height: 4rem;

          .goods-box-content-item-label {
            display: flex;
            align-items: center;
            justify-content: center;
            min-width: 8rem;
            width: 8rem;
            color: #ffffff;
            background-color: rgb(150, 162, 195);
          }

          .goods-box-content-item-list {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            flex-basis: 1;
            flex-grow: 1;
            padding: 15px 20px;
            font-size: .9rem;
            // display: flex;
            background-image: linear-gradient(to right,rgb(228,231,240),rgba(228,231,240,0) );
            .goods-count-mark{
              color: rgb(14, 122, 205);
              font-weight: bold;
              font-size: 1rem;
            }
          }
        }


        .goods-box-content-item:nth-child(odd) {
          .goods-box-content-item-label {
            background-color: rgb(107, 124, 170);
          }
          .goods-box-content-item-list{
            background-image: none;
            background-color: #ffffff;
          }
        }
      }
    }
  }
}
</style>